<div class="info-card">
  <div class="side-strip"></div>
  <div class="info-card-body">
    <div class="info-card-header">
      <div class="info-card-primary-title-container">
        <div class="info-card-primary-title" appLongTextTooltip>
          {{ card.primaryCardTitle }}
        </div>
        <div class="info-card-primary-status">
          @if (card.hasInlineWebhook) {
            <div class="inline-webhook-tag" matTooltip="Connected to in-line webhook">in-line</div>
          }
          @if (card.statusLabel) {
            <app-status-label [statusLabel]="card.statusLabel" [statusTooltip]="card.statusTooltip"> </app-status-label>
          }
        </div>
      </div>
      <div class="info-card-action-menu">
        @if (card.menuActions && card.menuActions.length > 0) {
          <app-actions-menu-icon
            [actions]="card.menuActions"
            (actionOnClick)="actionOnClick($event)"
            [smallSize]="true"
          >
          </app-actions-menu-icon>
        }
      </div>
    </div>
    <div class="info-card-secondary">
      <div class="title">{{ card.secondaryCardTitle }}</div>
      <div class="description">{{ card.secondaryCardValue }}</div>
      @if (card.secondaryCardTooltipText) {
        <div class="img-info">
          <img
            src="assets/images/common/info.svg"
            width="14"
            [matTooltip]="card.secondaryCardTooltipText"
            matTooltipPosition="right"
            matTooltipClass="tooltip__white"
          />
        </div>
      }
    </div>
    <div class="info-card-content">
      <div class="left-column">
        <app-card-fields [cardFields]="card.leftCardFields" [verticalOrder]="true"></app-card-fields>
      </div>
      <div class="right-column">
        <app-card-fields [cardFields]="card.rightCardFields" [verticalOrder]="true"></app-card-fields>
      </div>
    </div>
  </div>
</div>
